export const exploreWorlds = [
  {
    id: 'zhongli',
    imgUrl: '/splash/zhongli.png',
    title: 'Zhongli',
    icone: '/element/Geo.svg',
  },
  {
    id: 'bennett',
    imgUrl: '/splash/bennett.png',
    title: 'Bennett',
    icone: '/element/Pyro.svg',
  },
  {
    id: 'faruzan',
    imgUrl: '/splash/faruzan.png',
    title: 'Faruzan',
    icone: '/element/Anemo.svg',
  },
  {
    id: 'xiao',
    imgUrl: '/splash/xiao.png',
    title: 'Xiao',
    icone: '/element/Anemo.svg',
  },
];

export const Anemo = [
  {
    id: 'zhongli',
    imgUrl: '/splash/zhongli.png',
    title: 'Zhongli',
    icone: '/element/Geo.svg',
    num : 1,
  },
  {
    id: 'bennett',
    imgUrl: '/splash/bennett.png',
    title: 'Bennett',
    icone: '/element/Pyro.svg',
    num : 2,
  },
  {
    id: 'faruzan',
    imgUrl: '/splash/faruzan.png',
    title: 'Faruzan',
    icone: '/element/Anemo.svg',
    num : 3,
  },
  {
    id: 'xiao',
    imgUrl: '/splash/xiao.png',
    title: 'Xiao',
    icone: '/element/Anemo.svg',
    num : 4,
  },
];

export const Electro = [
  {
    id: 'shougun',
    imgUrl: '/splash/shougun.png',
    title: 'Shougun',
    icone: '/element/Electro.svg',
    num : 1,
  },
  {
    id: 'bennett',
    imgUrl: '/splash/bennett.png',
    title: 'Bennett',
    icone: '/element/Pyro.svg',
    num : 2,
  },
  {
    id: 'kazuha',
    imgUrl: '/splash/kazuha.png',
    title: 'Kazuha',
    icone: '/element/Anemo.svg',
    num : 3,
  },
  {
    id: 'sara',
    imgUrl: '/splash/sara.png',
    title: 'Sara',
    icone: '/element/Electro.svg',
    num : 4,
  },
];

export const Geo = [
  {
    id: 'zhongli',
    imgUrl: '/splash/zhongli.png',
    title: 'Zhongli',
    icone: '/element/Geo.svg',
    num : 1,
  },
  {
    id: 'xiangling',
    imgUrl: '/splash/xiangling.png',
    title: 'Xiangling',
    icone: '/element/Pyro.svg',
    num : 2,
  },
  {
    id: 'gorou',
    imgUrl: '/splash/gorou.png',
    title: 'Gorou',
    icone: '/element/Geo.svg',
    num : 3,
  },
  {
    id: 'Itto',
    imgUrl: '/splash/Itto.png',
    title: 'Itto',
    icone: '/element/Geo.svg',
    num : 4,
  },
];

export const Cryo = [
  {
    id: 'ayaka',
    imgUrl: '/splash/ayaka.png',
    title: 'Ayaka',
    icone: '/element/Cryo.svg',
    num : 1,
  },
  {
    id: 'rosaria',
    imgUrl: '/splash/rosaria.png',
    title: 'Rosaria',
    icone: '/element/Cryo.svg',
    num : 2,
  },
  {
    id: 'kazuha',
    imgUrl: '/splash/kazuha.png',
    title: 'Kazuha',
    icone: '/element/Anemo.svg',
    num : 3,
  },
  {
    id: 'mona',
    imgUrl: '/splash/mona.png',
    title: 'Mona',
    icone: '/element/Hydro.svg',
    num : 4,
  },
];

export const Pyro = [
  {
    id: 'ayaka',
    imgUrl: '/splash/ayaka.png',
    title: 'Ayaka',
    icone: '/element/Cryo.svg',
    num : 1,
  },
  {
    id: 'bennett',
    imgUrl: '/splash/bennett.png',
    title: 'Bennett',
    icone: '/element/Pyro.svg',
    num : 2,
  },
  {
    id: 'kazuha',
    imgUrl: '/splash/kazuha.png',
    title: 'Kazuha',
    icone: '/element/Anemo.svg',
    num : 3,
  },
  {
    id: 'diluc',
    imgUrl: '/splash/diluc.png',
    title: 'Diluc',
    icone: '/element/Pyro.svg',
    num : 4,
  },
];

export const startingFeatures = [
  'Collect rewards : Primogems, resources, and daily login bonuses.',
  'Complete quests and events : Obtain extra rewards and story developments.',
  'Explore the map : Find hidden chests, rare materials, and puzzles.',
];

export const newFeatures = [
  {
    imgUrl: '/vermillion.png',
    title: 'Vermillion',
    subtitle:
        'Vermillion Hereafter : Need the full set for Xiao',
  },
  {
    imgUrl: '/echo.png',
    title: 'Echoes',
    subtitle:
        'Echoes of an Offering : for two sets pieces',
  },
];

export const insights = [
  {
    imgUrl: '/lantern-rite.jpg',
    title: 'Genshin Impact : A Captivating RPG',
    subtitle:
        'Genshin Impact is a hit open-world RPG game that captivates players with its stunning graphics, captivating storyline, and engaging gameplay.',
  },
  {
    imgUrl: '/Kaedahara-Kazuha.jpg',
    title: 'Mastering Genshin Impact : Tips and Tricks',
    subtitle:
        'To master the game, focus on leveling up characters, building a strong team, exploring the world, gathering resources, learning combat, completing quests, and playing co-op with friends.',
  },
  {
    imgUrl: '/golden-apple.jpg',
    title: 'Explore the Magical World of Teyvat in Genshin Impact',
    subtitle:
        'With Genshin Impact, players can explore the magical world of Teyvat with its diverse landscapes, stunning vistas, and hidden secrets all in one platform.',
  },
];

export const socials = [
  {
    name: 'twitter',
    url: '/twitter.svg',
  },
  {
    name: 'linkedin',
    url: '/linkedin.svg',
  },
  {
    name: 'instagram',
    url: '/instagram.svg',
  },
  {
    name: 'facebook',
    url: '/facebook.svg',
  },
];
